var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('botao-tooltip',{attrs:{"icone":"mdi-reply","cor":"grey","texto":"Descancelar"},on:{"click":_vm.descancelar}})}
var staticRenderFns = []

export { render, staticRenderFns }